import { useState, useRef, useCallback } from 'react';

/**
 * Ref-guarded async runner so concurrent calls are ignored before React re-renders.
 * Use `loading` for single-action dialogs; use `run(fn, key)` + `isPending(key)` for per-row actions.
 */
export function useAsyncAction() {
  const inFlight = useRef(false);
  const [loading, setLoading] = useState(false);
  const [pendingKey, setPendingKey] = useState(null);

  const run = useCallback(async (fn, key = null) => {
    if (inFlight.current) return;
    inFlight.current = true;
    setLoading(true);
    if (key != null) setPendingKey(key);
    try {
      return await fn();
    } finally {
      inFlight.current = false;
      setLoading(false);
      setPendingKey(null);
    }
  }, []);

  const isPending = useCallback(
    (key) => (key != null ? pendingKey === key : loading),
    [pendingKey, loading]
  );

  return { loading, pendingKey, run, isPending };
}
